import React from "react";
import { setStatusClass } from "../../utils/styles";
import themePropTypes from "../theme-prop-types";
import { v4 as uuidv4 } from "uuid";

const TaskList = ({ tasks }) => {
  return (
    <div className='tasks'>
      {tasks.map(task =>
        task.type === "divider" ? (
          <div key={`${task.type}_${uuidv4()}`} className='divider' />
        ) : task.type === "item" ? (
          <div key={`${task.type}_${uuidv4()}`} className='task-wrapper'>
            <div
              className='title'
              dangerouslySetInnerHTML={{ __html: task.title.text }}
            />
            <div className='task-info'>
              <p
                className={`status ${setStatusClass(
                  task.subtitle.text.split("|")[0].trim()
                )}`}
              >
                {task.subtitle.text.split("|")[0].trim()}
              </p>
              {task.subtitle.text.split("|").length === 2 && (
                <p className='date'>
                  {task.subtitle.text.split("|")[1].trim()}
                </p>
              )}
            </div>
          </div>
        ) : null
      )}
    </div>
  );
};

TaskList.propTypes = themePropTypes.input;

export default TaskList;
